import React from 'react';


const MonthView = ({ currentDate, appointments, onDateClick, onAppointmentClick }) => {
  const year = currentDate?.getFullYear();
  const month = currentDate?.getMonth();

  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const startDate = new Date(firstDay);
  startDate?.setDate(startDate?.getDate() - firstDay?.getDay());

  const days = [];
  const currentDay = new Date(startDate);
  
  while (days?.length < 42) {
    days?.push(new Date(currentDay));
    currentDay?.setDate(currentDay?.getDate() + 1);
  }

  const getAppointmentsForDay = (date) => {
    return appointments?.filter(apt => {
      const aptDate = new Date(apt.startTime);
      return (aptDate?.getDate() === date?.getDate() &&
      aptDate?.getMonth() === date?.getMonth() && aptDate?.getFullYear() === date?.getFullYear());
    });
  };

  const isToday = (date) => {
    const today = new Date();
    return (date?.getDate() === today?.getDate() &&
    date?.getMonth() === today?.getMonth() && date?.getFullYear() === today?.getFullYear());
  };

  const isCurrentMonth = (date) => {
    return date?.getMonth() === month;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-success';
      case 'pending':
        return 'bg-warning';
      case 'cancelled':
        return 'bg-muted-foreground';
      case 'completed':
        return 'bg-primary';
      default:
        return 'bg-muted';
    }
  };

  return (
    <div className="bg-card">
      <div className="grid grid-cols-7 border-b border-border">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']?.map((day) => (
          <div key={day} className="p-4 text-center bg-muted">
            <span className="text-sm font-semibold text-foreground">{day}</span>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7">
        {days?.map((day, idx) => {
          const dayAppointments = getAppointmentsForDay(day);
          const isCurrentMonthDay = isCurrentMonth(day);
          const isTodayDay = isToday(day);

          return (
            <button
              key={idx}
              onClick={() => onDateClick(day)}
              className={`min-h-[120px] p-2 border-b border-r border-border text-left transition-smooth hover:bg-muted/50 ${
                !isCurrentMonthDay ? 'bg-muted/30' : ''
              } ${isTodayDay ? 'bg-primary/5' : ''}`}
            >
              <div className="flex items-center justify-between mb-2">
                <span className={`text-sm font-semibold ${
                  !isCurrentMonthDay ? 'text-muted-foreground' : 
                  isTodayDay ? 'text-primary' : 'text-foreground'
                }`}>
                  {day?.getDate()}
                </span>
                {dayAppointments?.length > 0 && (
                  <span className="flex items-center justify-center w-6 h-6 bg-primary text-primary-foreground text-xs font-semibold rounded-full">
                    {dayAppointments?.length}
                  </span>
                )}
              </div>
              <div className="space-y-1">
                {dayAppointments?.slice(0, 3)?.map((apt) => (
                  <button
                    key={apt?.id}
                    onClick={(e) => {
                      e?.stopPropagation();
                      onAppointmentClick(apt);
                    }}
                    className={`w-full p-1.5 rounded text-left text-xs transition-smooth hover:shadow-sm ${getStatusColor(apt?.status)} text-white`}
                  >
                    <p className="font-medium truncate">
                      {new Date(apt.startTime)?.toLocaleTimeString('en-US', { 
                        hour: 'numeric', 
                        minute: '2-digit' 
                      })}
                    </p>
                    <p className="truncate opacity-90">{apt?.patientName}</p>
                  </button>
                ))}
                {dayAppointments?.length > 3 && (
                  <div className="text-xs text-muted-foreground text-center pt-1">
                    +{dayAppointments?.length - 3} more
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MonthView;